export const links = [
    {
        id: 0,
        link: "Terms of Services",
        path: "/terms-of-service"
    },
    {
        id: 1,
        link: "Subscription Terms",
        path: "/subscription-terms"
    },
    {
        id: 2,
        link: "Permitted use policy",
        path: "/permitted-use-policy"
    },
    {
        id: 3,
        link: "Privacy Policy",
        path: "/privacy-policy"
    },
    {
        id: 4,
        link: "Cookies Policy",
        path: "/cookies-policy"
    },
    {
        id: 5,
        link: "FAQ",
        path: "/faq"
    },
    /*{
        id: 6,
        link: "Developer",
        path: "https://developers.sharepass.com"
    }*/
];